/* global tinymce, wp */
// import smartContentIconSvg from '@sharedAssets/icons/smart-content-sync-editor-icon.svg';

const MODAL_ID = 'smartcontentsync-classic-modal';
// const OPEN_CLASS = 'is-open';
const OPEN_CLASS = 'is-active';
console.log('[SmartContentSync] tinymceSmartContentButton.js loaded', {
  MODAL_ID: 'smartcontentsync-classic-modal',
});
const insertSmartContent =
  window.smartContentSyncAdminData?.localization?.wordPress?.editors?.classic?.insertSmartContent ||
  'Insert Smart Content';
const search = window.smartContentSyncAdminData?.localization?.search || 'Search';
const searchSmartContent =
  window.smartContentSyncAdminData?.localization?.searchSmartContent || 'Search Smart Content';
const selectSmartContent =
  window.smartContentSyncAdminData?.localization?.selectSmartContent || 'Select Smart Content';
const noResults = window.smartContentSyncAdminData?.localization?.noResultsFound || 'No results.';
const shortcodeAttribute =
  window.smartContentSyncAdminData?.localization?.shortcodeAttribute || 'Shortcode Attribute';
const optional = window.smartContentSyncAdminData?.localization?.optional || 'Optional';
const attributeDescription =
  window.smartContentSyncAdminData?.localization?.attributeDescription ||
  'Use standard shortcode attributes (e.g. <code>title=&quot;Hello&quot;</code>).';
const attributeKey =
  window.smartContentSyncAdminData?.localization?.attributeKey || 'Attribute Key';
const value = window.smartContentSyncAdminData?.localization?.value || 'Value';
const shortcodePreview =
  window.smartContentSyncAdminData?.localization?.shortcodePreview || 'Shortcode Preview';
const shortcodePreviewDescription =
  window.smartContentSyncAdminData?.localization?.shortcodePreviewDescription ||
  'This is what will be inserted into the editor.';
const insert = window.smartContentSyncAdminData?.localization?.insert || 'Insert';
const cancel = window.smartContentSyncAdminData?.localization?.cancel || 'Cancel';

function svgToDataUrl(svg) {
  // Safer than btoa for unicode SVGs
  const encoded = encodeURIComponent(svg).replace(/'/g, '%27').replace(/"/g, '%22');

  return `data:image/svg+xml,${encoded}`;
}
function ensureModalExists() {
  if (document.getElementById(MODAL_ID)) return;

  const modalHtml = `
    <div
      id="${MODAL_ID}"
      class="andale-vue-modal andale-modal smartcontentsync-classic-modal"
      aria-hidden="true"
    >
      <!-- Backdrop -->
      <div
        class="andale-vue-modal-background smartcontentsync-classic-modal__backdrop"
        data-smart-content-sync-close="1"
      ></div>

      <!-- Dialog -->
      <div
        class="andale-vue-modal-content smartcontentsync-classic-modal__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="${MODAL_ID}__title"
      >
        <button
          type="button"
          class="andale-vue-modal-close andale-vue-modal-close-icon smartcontentsync-classic-modal__close"
          data-smart-content-sync-close="1"
          aria-label="Close"
        >
          ×
        </button>

        <div class="andale-vue-modal-body">
          <h2
            class="andale-vue-modal-title smartcontentsync-classic-modal__title"
            id="${MODAL_ID}__title"
          >
            ${insertSmartContent}
          </h2>

          <div class="andale-vue-modal-content-body">
            <div class="smartcontentsync-classic-modal__body">

              <!-- Step 1 -->
              <div class="smartcontentsync-classic-modal__step">
                <div class="smartcontentsync-classic-modal__stepHeader">
                  <span class="smartcontentsync-classic-modal__stepBadge">1</span>
                  <h3 class="smartcontentsync-classic-modal__stepTitle">${selectSmartContent}</h3>
                </div>

                <div class="smartcontentsync-classic-modal__row">
                  <input type="text" class="smartcontentsync-classic-modal__search" placeholder="${searchSmartContent}…" />
                  <button type="button" class="button smartcontentsync-classic-modal__searchBtn">${search}</button>
                </div>

                <div class="smartcontentsync-classic-modal__results" aria-live="polite">
                  <div class="smartcontentsync-classic-modal__resultsList"></div>
                </div>
              </div>

              <!-- Step 2 -->
              <div class="smartcontentsync-classic-modal__step">
                <div class="smartcontentsync-classic-modal__stepHeader">
                  <span class="smartcontentsync-classic-modal__stepBadge">2</span>
                  <h3 class="smartcontentsync-classic-modal__stepTitle">${shortcodeAttribute} (${optional})</h3>
                </div>

                <p class="description">${attributeDescription}</p>

                <div class="smartcontentsync-classic-modal__attrRow">
                  <input type="text" class="smartcontentsync-classic-modal__attrKey" placeholder="${attributeKey}" />
                  <input type="text" class="smartcontentsync-classic-modal__attrVal" placeholder="${value}" />
                  <button type="button" class="button smartcontentsync-classic-modal__addAttr">Add</button>
                </div>

                <div class="smartcontentsync-classic-modal__attrList"></div>
              </div>

              <!-- Step 3 -->
              <div class="smartcontentsync-classic-modal__step">
                <div class="smartcontentsync-classic-modal__stepHeader">
                  <span class="smartcontentsync-classic-modal__stepBadge">3</span>
                  <h3 class="smartcontentsync-classic-modal__stepTitle">${shortcodePreview}</h3>
                </div>

                <p class="description">${shortcodePreviewDescription}</p>

                <div class="smartcontentsync-classic-modal__previewRow">
                  <input type="text" class="smartcontentsync-classic-modal__previewInput" readonly />
                  <button type="button" class="button smartcontentsync-classic-modal__copyPreview" disabled>Copy</button>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="andale-vue-modal-footer smartcontentsync-classic-modal__footer">
          <div class="smartcontentsync-classic-modal__selected"></div>
          <button type="button" class="button button-primary smartcontentsync-classic-modal__insert" disabled>${insert}</button>
          <button type="button" class="button smartcontentsync-classic-modal__cancel" data-smart-content-sync-close="1">${cancel}</button>
        </div>
      </div>
    </div>
  `;

  const wrapper = document.createElement('div');
  wrapper.innerHTML = modalHtml.trim();
  const modalEl = wrapper.firstElementChild;
  if (!modalEl) return;

  document.body.appendChild(modalEl);
}

// function closeModal() {
//   const modal = document.getElementById(MODAL_ID);
//   if (!modal) return;

//   modal.classList.remove(OPEN_CLASS);
//   modal.setAttribute('aria-hidden', 'true');
//   document.body.classList.remove('andale-modal-open');
// }

// function openModal() {
//   ensureModalExists();

//   const modal = document.getElementById(MODAL_ID);
//   if (!modal) return;

//   modal.classList.add(OPEN_CLASS);
//   modal.setAttribute('aria-hidden', 'false');

//   document.body.classList.add('andale-modal-open');

//   if (!modal.__smartContentSyncInitialized) {
//     initModalHandlers(modal);
//     modal.__smartContentSyncInitialized = true;
//   }
// }

function closeModal() {
  const modal = document.getElementById(MODAL_ID);
  if (!modal) return;

  modal.classList.remove(OPEN_CLASS);
  modal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('andale-modal-open');
  document.body.style.overflow = '';
}

function openModal() {
  ensureModalExists();

  const modal = document.getElementById(MODAL_ID);
  if (!modal) return;

  modal.classList.add(OPEN_CLASS);
  modal.setAttribute('aria-hidden', 'false');
  document.body.classList.add('andale-modal-open');
  document.body.style.overflow = 'hidden';

  if (!modal.__smartContentSyncInitialized) {
    initModalHandlers(modal);
    modal.__smartContentSyncInitialized = true;
  }
}

function escapeAttrValue(value) {
  return String(value).replace(/"/g, '&quot;');
}

function buildShortcode(smartContentId, attrsKvp) {
  // NOTE: Adjust 'id' if your shortcode uses a different attribute name.
  let shortcode = `[smart_content id="${escapeAttrValue(smartContentId)}"`;

  Object.keys(attrsKvp).forEach((key) => {
    const val = attrsKvp[key];
    if (val === null || typeof val === 'undefined') return;
    if (!key) return;

    shortcode += ` ${key}="${escapeAttrValue(val)}"`;
  });

  shortcode += `]`;
  return shortcode;
}

function insertIntoActiveEditor(shortcode) {
  if (window.tinymce && tinymce.activeEditor && !tinymce.activeEditor.isHidden()) {
    tinymce.activeEditor.execCommand('mceInsertContent', false, shortcode);
    return;
  }

  const textarea = document.getElementById('content');
  if (!textarea) return;

  const start = textarea.selectionStart || 0;
  const end = textarea.selectionEnd || 0;
  const before = textarea.value.substring(0, start);
  const after = textarea.value.substring(end);

  textarea.value = `${before}${shortcode}${after}`;
  textarea.focus();
  textarea.selectionStart = textarea.selectionEnd = start + shortcode.length;
}

// function renderResults(container, items, onSelect) {
//   if (!items || items.length === 0) {
//     container.innerHTML = `<p class="description">No results.</p>`;
//     return;
//   }

//   container.innerHTML = items
//     .map((item) => {
//       const title = item?.title?.rendered ? item.title.rendered : `(ID: ${item.id})`;
//       return `
//         <button type="button" class="smartcontentsync-classic-modal__result" data-smart-content-sync-id="${item.id}">
//           <span class="smartcontentsync-classic-modal__resultTitle">${title}</span>
//           <span class="smartcontentsync-classic-modal__resultMeta">#${item.id}</span>
//         </button>
//       `;
//     })
//     .join('');

//   container.querySelectorAll('[data-smart-content-sync-id]').forEach((btn) => {
//     btn.addEventListener('click', () =>
//       onSelect(parseInt(btn.getAttribute('data-smart-content-sync-id'), 10))
//     );
//   });
// }
function statusLabel(status) {
  if (!status) return '';
  const s = String(status).toLowerCase();
  if (s === 'publish') return '';
  if (s === 'draft') return 'Draft';
  if (s === 'private') return 'Private';
  if (s === 'pending') return 'Pending';
  if (s === 'future') return 'Scheduled';
  return s;
}

function renderResults(container, items, selectedId, onSelect) {
  if (!items || items.length === 0) {
    container.innerHTML = `<p class="description">No results.</p>`;
    return;
  }

  container.innerHTML = items
    .map((item) => {
      const title = item?.title?.rendered ? item.title.rendered : `(ID: ${item.id})`;
      const isSelected = Number(item.id) === Number(selectedId);
      const badge = statusLabel(item?.status);

      return `
        <button type="button"
          class="smartcontentsync-classic-modal__result ${isSelected ? 'is-selected' : ''}"
          data-smart-content-sync-id="${item.id}">
          <span class="smartcontentsync-classic-modal__resultTitle">${title}</span>
          <span class="smartcontentsync-classic-modal__resultRight">
            ${badge ? `<span class="smartcontentsync-classic-modal__status">${badge}</span>` : ''}
            <span class="smartcontentsync-classic-modal__resultMeta">#${item.id}</span>
          </span>
        </button>
      `;
    })
    .join('');

  container.querySelectorAll('[data-smart-content-sync-id]').forEach((btn) => {
    btn.addEventListener('click', () => {
      onSelect(parseInt(btn.getAttribute('data-smart-content-sync-id'), 10));
    });
  });
}

function initModalHandlers(modal) {
  const closeEls = modal.querySelectorAll('[data-smart-content-sync-close="1"]');
  closeEls.forEach((el) => el.addEventListener('click', closeModal));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains(OPEN_CLASS)) closeModal();
  });

  const searchInput = modal.querySelector('.smartcontentsync-classic-modal__search');
  const searchBtn = modal.querySelector('.smartcontentsync-classic-modal__searchBtn');
  const resultsEl = modal.querySelector('.smartcontentsync-classic-modal__resultsList');
  const selectedEl = modal.querySelector('.smartcontentsync-classic-modal__selected');
  const insertBtn = modal.querySelector('.smartcontentsync-classic-modal__insert');

  const attrKeyEl = modal.querySelector('.smartcontentsync-classic-modal__attrKey');
  const attrValEl = modal.querySelector('.smartcontentsync-classic-modal__attrVal');
  const addAttrBtn = modal.querySelector('.smartcontentsync-classic-modal__addAttr');
  const attrListEl = modal.querySelector('.smartcontentsync-classic-modal__attrList');

  const previewInput = modal.querySelector('.smartcontentsync-classic-modal__previewInput');
  const copyPreviewBtn = modal.querySelector('.smartcontentsync-classic-modal__copyPreview');

  let lastItems = [];
  let searchTimer = null;

  let selectedId = null;
  const attrsKvp = {};

  const localizations = {
    selected: window.smartContentSyncAdminData?.localization.selected || 'Selected',
    noSmartContentSelected:
      window.smartContentSyncAdminData?.localization?.noSmartContentSelected ||
      'No Smart Content selected.',
    noAttributesAdded:
      window.smartContentSyncAdminData?.localization?.noAttributesAdded || 'No attributes added.',
    remove: window.smartContentSyncAdminData?.localization?.remove || 'Remove',
  };

  function updateSelectedUI() {
    if (!selectedId) {
      selectedEl.innerHTML = `<span class="description">${localizations.noSmartContentSelected}</span>`;
      insertBtn.disabled = true;
      renderPreview();
      return;
    }
    selectedEl.innerHTML = `<strong>${localizations.selected}:</strong> #${selectedId}`;
    insertBtn.disabled = false;
    renderPreview();
  }

  function updateAttrListUI() {
    const keys = Object.keys(attrsKvp);
    if (keys.length === 0) {
      attrListEl.innerHTML = `<p class="description">${localizations.noAttributesAdded}</p>`;
      renderPreview();
      return;
    }

    attrListEl.innerHTML = keys
      .map((k) => {
        const v = attrsKvp[k];
        return `
        <div class="smartcontentsync-classic-modal__attrItem">
          <code>${k}="${escapeAttrValue(v)}"</code>
          <button type="button" class="button-link smartcontentsync-classic-modal__removeAttr" data-smart-content-sync-rm="${k}">${
            localizations.remove
          }</button>
        </div>
      `;
      })
      .join('');

    attrListEl.querySelectorAll('[data-smart-content-sync-rm]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const key = btn.getAttribute('data-smart-content-sync-rm');
        delete attrsKvp[key];
        updateAttrListUI();
      });
    });

    renderPreview();
  }

  function renderPreview() {
    if (!previewInput) return;

    if (!selectedId) {
      previewInput.value = '';
      if (copyPreviewBtn) copyPreviewBtn.disabled = true;
      return;
    }

    previewInput.value = buildShortcode(selectedId, attrsKvp);
    if (copyPreviewBtn) copyPreviewBtn.disabled = false;
  }

  async function fetchSmartContentList(query) {
    const params = new URLSearchParams();
    params.set('per_page', '20');
    params.set('orderby', 'modified');
    params.set('order', 'desc');
    if (query) {
      params.set('search', query);
    }
    // // "Almost any" = everything except trash
    // params.set('status', 'publish,draft,pending,private,future');
    params.set('status', 'any');

    return wp.apiFetch({ path: `/wp/v2/smart-content?${params.toString()}` });
  }

  // async function doSearch() {
  //   const q = (searchInput.value || '').trim();
  //   resultsEl.innerHTML = `<p class="description">Searching…</p>`;

  //   try {
  //     const items = await fetchSmartContentList(q);
  //     renderResults(resultsEl, items, (id) => {
  //       selectedId = id;
  //       updateSelectedUI();
  //     });
  //   } catch (err) {
  //     // eslint-disable-next-line no-console
  //     console.error(err);
  //     resultsEl.innerHTML = `<p class="description">Search failed. Check console.</p>`;
  //   }
  // }

  function handleSelect(id) {
    selectedId = id;
    updateSelectedUI();
    renderResults(resultsEl, lastItems, selectedId, handleSelect);
  }

  async function doSearch() {
    const q = (searchInput.value || '').trim();
    resultsEl.innerHTML = `<p class="description">Searching…</p>`;

    try {
      lastItems = await fetchSmartContentList(q);
      renderResults(resultsEl, lastItems, selectedId, handleSelect);
    } catch (err) {
      console.error(err);
      resultsEl.innerHTML = `<p class="description">Search failed. Check console.</p>`;
    }
  }

  function resetModalState() {
    selectedId = null;
    lastItems = [];
    Object.keys(attrsKvp).forEach((k) => delete attrsKvp[k]);

    searchInput.value = '';
    attrKeyEl.value = '';
    attrValEl.value = '';

    resultsEl.innerHTML = `<p class="description">Type to search.</p>`;
    updateSelectedUI();
    updateAttrListUI();
    renderPreview();
  }

  modal.__smartContentSyncReset = resetModalState;

  searchBtn.addEventListener('click', doSearch);
  searchInput.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') doSearch();
  });
  searchInput.addEventListener('input', () => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(doSearch, 300);
  });
  if (copyPreviewBtn) {
    copyPreviewBtn.addEventListener('click', async () => {
      const text = previewInput?.value || '';
      if (!text) return;

      try {
        await navigator.clipboard.writeText(text);
      } catch (e) {
        // fallback
        previewInput.focus();
        previewInput.select();
        document.execCommand('copy');
      }
    });
  }
  if (insertBtn) {
    insertBtn.addEventListener('click', () => {
      if (!selectedId) return;
      insertIntoActiveEditor(buildShortcode(selectedId, attrsKvp));
      if (typeof modal.__smartContentSyncReset === 'function') {
        modal.__smartContentSyncReset();
      }
      closeModal();
    });
  }

  addAttrBtn.addEventListener('click', () => {
    const key = (attrKeyEl.value || '').trim();
    const val = (attrValEl.value || '').trim();
    if (!key) return;

    attrsKvp[key] = val;
    attrKeyEl.value = '';
    attrValEl.value = '';
    updateAttrListUI();
  });

  insertBtn.addEventListener('click', () => {
    if (!selectedId) return;
    insertIntoActiveEditor(buildShortcode(selectedId, attrsKvp));
    closeModal();
  });

  updateSelectedUI();
  updateAttrListUI();
  doSearch();
}

/**
 * Initialize the Classic Editor TinyMCE integration.
 * Call this once (from your main admin entry) after DOM is ready.
 *
 * @param {Object} [options]
 * @param {Function} [options.onOpen] Optional hook called when modal opens.
 */
export function initSmartContentSyncClassicEditorTinyMCE(options = {}) {
  // Guard: only relevant when TinyMCE is available (Classic Editor visual mode)
  if (!window.tinymce || !tinymce.PluginManager) {
    return;
  }
  // Avoid double-registering if bundle is loaded twice
  if (window.__smartContentSyncTinyMCERegistered) {
    return;
  }
  window.__smartContentSyncTinyMCERegistered = true;
  // const iconUrl = svgToDataUrl(smartContentIconSvg);

  tinymce.PluginManager.add('smart_content_sync_smart_content', function (editor) {
    editor.addButton('smart_content_sync_smart_content', {
      tooltip: insertSmartContent,
      text: '',
      icon: 'smartcontentsync-smart-content', // -> .mce-i-smartcontentsync-smart-content /* iconUrl */,
      onclick: () => {
        if (typeof options.onOpen === 'function') {
          options.onOpen();
        }
        openModal();
      },
    });

    return {
      getMetadata: function () {
        return { name: 'SmartContentSync', url: '' };
      },
    };
  });

  // Optional: allow metabox to open the same modal
  window.smartContentSyncClassicEditorOpenSmartContentModal = openModal;
}
